/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// window.Vue   = require('vue')
// window.jszip = require('jszip')

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// theme
require("../../vendor/psagroupeuk/theme/resources/theme/psagroupe/js/theme");

require("./bootstrap");
require("../../vendor/snapappointments/bootstrap-select/js/bootstrap-select.js");

//load plugins
require("./plugins/tinymyce");
require("./plugins/savy.min");
require("./plugins/datatable-page-select");
require("./plugins/jquery.expandable");


require("./modules/clipboard-helper");

// override data tables to display default contents
$.extend(true, $.fn.dataTable.defaults, {
    // 'sPaginationType': 'listbox',
    columnDefs: [
        {
            targets: "_all",
            defaultContent: "-",
        },
    ],
    pageLength: (() => {
        const envValue = process.env.MIX_RECORDS_PER_PAGE;
        const parsedValue = parseInt(envValue, 10);
        if (isNaN(parsedValue)) {
            return 10; // Default to 10 if not a valid number
        }
        return parsedValue;
    })(),
});

/**
 * override data tables to display language file,
 * read the dot env MIX_APP_LOCALE variable
 */
if (process.env.MIX_APP_LOCALE != "en") {
    $.extend(true, $.fn.dataTable.defaults, {
        language: {
            url: "/js/dataTables.json",
        },
        stateSave: `{{ config('system.keep_datatable_filters') }}`,
        bStateSave: `{{ config('system.keep_datatable_filters') }}`,
    });
}
